import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Checkbox } from "antd";
import { FadeView, ShipmentSteps } from "../common";

import { GoChevronRight } from "react-icons/go";

import { TransportTypeOption } from "./transport-type";

import { Shipment, TransportType } from "../../model";

import { transportTypes } from "../../reference/TransportType";

import * as Master from "../../reference/Master";

import { CacheService, ReferenceService } from "../../service";

import "./ChangeTransportType.css";

function ChangeTransportType(props: any) {
   const history = useHistory();
   const { match }: any = props;
   const shipment: Shipment = props.shipment;
   const [requireTkbm, setRequireTkbm] = useState(shipment.isReqTransWorker ? true : false);
   const [transTypes, setTransTypes] = useState(transportTypes.filter((transportType: TransportType) => new RegExp(match.params.category, "i").test(transportType.category)));

   useEffect(() => {
      CacheService.savePrev();
      props.setShowBackNavigation(true);
      props.setShowBottomNavigation(false);
   }, [props]);

   const onSelectTransportType = (transportType: TransportType) => {
      shipment.transportTypeCode = transportType.code;
      shipment.transportTypeDesc = transportType.desc;
      CacheService.setNewShipment(shipment);
      CacheService.setProvider(undefined);
      history.replace("/select-provider");
   };

   const requireTkbmSelected = (e: any) => {
      shipment.isReqTransWorker = e.target.checked;
      setRequireTkbm(e.target.checked);
   };

   useEffect(() => {
      props.setShowBottomNavigation(false);
      if (transportTypes.length === 0) {
         ReferenceService.initTransportTypes().then((result) => {
            const types = result.filter((transportType: TransportType) => new RegExp(match.params.category, "i").test(transportType.category));
            setTransTypes(types);
         });
      }
   }, [props, match.params.category]);

   const onChangeCategory = () => {
      history.push("/change-category");
   };

   return (
      <div className="change-transport-type">
         <div className="change-transport-type-content">
            <ShipmentSteps status={Master.SHIPMENT_STATUS_NEW_ORDER} />
            <FadeView show={true} duration="0">
               <div className="change-transport-type-header regular-bottom-border">
                  <div className="change-transport-change-type regular-bottom-border" onClick={onChangeCategory}>
                     <div className="regular-bold-font">Ganti Kategori Angkutan</div>
                     <div>
                        <GoChevronRight className="change-transport-navigate" />
                     </div>
                  </div>
                  <div className="change-transport-type-option">
                     <div className="regular-bold-font">Tipe Angkutan</div>
                     <Checkbox onClick={requireTkbmSelected} checked={requireTkbm} className="tkbm regular-bold-font">
                        Membutuhkan tenaga kerja bongkar muat
                     </Checkbox>
                  </div>
               </div>
               <TransportTypeOption data={transTypes} onSelect={onSelectTransportType} />
            </FadeView>
         </div>
      </div>
   );
}

export default ChangeTransportType;
